import {prepareFormValidation} from "../components/forms/validation"
import Swal from "sweetalert2"
import Cookies from "js-cookie"

if(document.getElementById("mailing-subscribe-form")){

    prepareFormValidation($("#mailing-subscribe-form"));

    $("#mailing-subscribe-form").on("submit", function(e){
        e.preventDefault();

        if(!$(this).valid()){
            if(typeof Ladda !== "undefined") Ladda.stopAll();
            return
        }

        const formData = $(this).serialize();
        $.post("/services/constant-contact/add-email.php", formData, function(data){
            console.log("FIRE")
            Swal.fire(
                "Thank you for subscribing",
                "Get 20% off your next order with discount code 20PERCENT",
                "success"
            )

            if(typeof Ladda !== "undefined") Ladda.stopAll();      
            Cookies.set("mailing", "true")      
        });

    })

}

